
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_8607_3219)"}},[_c('path',{attrs:{"d":"M23.856 23.146l-6.443-6.443a9.949 9.949 0 002.596-6.697c-.001-5.514-4.487-10-10.001-10-5.514 0-10 4.486-10 10s4.486 10 10 10a9.949 9.949 0 006.697-2.596l6.443 6.443a.498.498 0 00.708 0 .5.5 0 000-.707zm-13.848-4.141c-4.962 0-9-4.037-9-9s4.037-9 9-9 9 4.038 9 9c0 4.964-4.038 9-9 9zm4.494-12.006c-.827 0-1.5.673-1.5 1.5v4.5h-1.5v-6.5c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5v6.5h-1.5v-3.5c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5v3c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5v-4c0-.827-.673-1.5-1.5-1.5zm-8.5 6h-.5a.5.5 0 01-.5-.5v-3a.5.5 0 011 0v3.5zm3.5-6.5a.5.5 0 011 0v6.5h-1v-6.5zm5.5 6a.5.5 0 01-.5.5h-.5v-4.5a.5.5 0 011 0v4z","fill":"#000C1F"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_8607_3219"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    